exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#splash .left-back,#splash .right-back{display:none}.splash-page{padding-bottom:130px}.splash-page .intro-txt{margin-top:30px;font-size:13px}.splash-page .action{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;margin-top:40px;margin-bottom:40px}.splash-page .action .no{border-top-right-radius:0;border-bottom-right-radius:0;border-width:0}.splash-page .action .enter{border-top-left-radius:0;border-bottom-left-radius:0;border-width:0}.splash-page .parents{font-size:13px;left:30px;right:30px;bottom:30px;position:absolute}.splash-page .parents p{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/autoprefixer-loader?{browsers:["last 3 versions"],cascade:false}!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader??ref--6-3!./components/splash/stylus/_splash.styl
// module id = 478
// module chunks = 4